/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutGroupRef,
  OptOutGroupRefOptional,
  OptOutGroupRefMetaI,
  OptOutGroupRefTrackedI,
} from "./opt-out-group-ref";
import { OptOutGroupRefTracked, OptOutGroupRefMeta } from "./opt-out-group-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutRequestFull,
  OptOutRequestFullOptional,
  OptOutRequestFullMetaI,
  OptOutRequestFullTrackedI,
} from "./opt-out-request-full";
import {
  OptOutRequestFullTracked,
  OptOutRequestFullMeta,
} from "./opt-out-request-full";

/**
 *
 * @export
 * @interface OptOutRequestInternal
 */
export interface OptOutRequestInternalOptional extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof OptOutRequestInternal
   */
  reqId?: number;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestInternal
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  email?: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof OptOutRequestInternal
   */
  optOutGrpId?: OptOutGroupRefOptional;
}

export interface OptOutRequestInternal
  extends OptOutRequestInternalOptional, DBHistory, OptOutRequestFull {
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof OptOutRequestInternal
   */
  reqId: number;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestInternal
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  email: string;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof OptOutRequestInternal
   */
  optOutGrpId?: OptOutGroupRef;
}

export interface OptOutRequestInternalTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OptOutRequestInternal
   */
  reqId?: number;
  reqIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestInternal
   */
  doNotSend?: boolean;
  doNotSendIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  token?: string;
  tokenIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestInternal
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {OptOutGroupRef}
   * @memberof OptOutRequestInternal
   */
  optOutGrpId?: OptOutGroupRefTrackedI;
  optOutGrpIdIsSet: boolean;
}

transformDatesMap.set(
  "OptOutRequestInternal",
  function (model: OptOutRequestInternal) {
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
    const transformDatesoptOutGrpId = transformDatesMap.get("OptOutGroupRef");
    if (transformDatesoptOutGrpId && model.optOutGrpId) {
      transformDatesoptOutGrpId(model.optOutGrpId);
    }
  },
);

export type OptOutRequestInternalMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reqId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  doNotSend: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  token: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  optOutGrpId: PropertyMeta<OptOutGroupRefMetaI>;
}>;

export var OptOutRequestInternalMeta: OptOutRequestInternalMetaI =
  {} as OptOutRequestInternalMetaI;
OptOutRequestInternalMeta = typeMeta("OptOutRequestInternal", {
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reqId: propertyMeta("reqId", false, true, true, MetaTypesBase.number),
  doNotSend: propertyMeta(
    "doNotSend",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  token: propertyMeta("token", false, false, false, MetaTypesBase.string),
  email: propertyMeta("email", false, true, false, MetaTypesBase.string),
  optOutGrpId: propertyMeta(
    "optOutGrpId",
    false,
    false,
    false,
    OptOutGroupRefMeta,
  ),
});

const metaI = OptOutRequestInternalMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
  metaI.interfaces = metaI.interfaces.concat([OptOutRequestFullMeta]);
  metaI.reqId.inheritedFrom = OptOutRequestFullMeta.reqId;
  metaI.doNotSend.inheritedFrom = OptOutRequestFullMeta.doNotSend;
  metaI.token.inheritedFrom = OptOutRequestFullMeta.token;
});

export class OptOutRequestInternalTracked
  extends DBHistoryTracked
  implements OptOutRequestInternalTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  reqId__I?: number = undefined;

  get reqIdIsSet() {
    return this.reqId !== undefined;
  }
  set reqIdIsSet(v: boolean) {}
  set reqId(v: undefined | number) {
    if (v !== undefined) {
      this.reqId__I = v;
      this.reqIdIsSet = true;
    } else {
      this.reqId__I = v || undefined;
      this.reqIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reqId() {
    return this.reqId__I;
  }
  doNotSend__I?: boolean = undefined;
  doNotSendIsSet: boolean = false;
  set doNotSend(v: undefined | boolean) {
    if (v !== undefined) {
      this.doNotSend__I = v;
      this.doNotSendIsSet = true;
    } else {
      this.doNotSend__I = v || undefined;
      this.doNotSendIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotSend() {
    return this.doNotSend__I;
  }
  token__I?: string = undefined;
  tokenIsSet: boolean = false;
  set token(v: undefined | string) {
    if (v !== undefined) {
      this.token__I = v;
      this.tokenIsSet = true;
    } else {
      this.token__I = v || undefined;
      this.tokenIsSet = false;
    }
    this.changeTracker = true;
  }
  get token() {
    return this.token__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = true;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  optOutGrpId__I?: OptOutGroupRefTracked = undefined;
  optOutGrpIdIsSet: boolean = false;
  set optOutGrpId(v: undefined | OptOutGroupRefTracked) {
    if (v !== undefined) {
      this.optOutGrpId__I = v;
      this.optOutGrpIdIsSet = true;
    } else {
      this.optOutGrpId__I = v || undefined;
      this.optOutGrpIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get optOutGrpId() {
    return this.optOutGrpId__I;
  }
  constructor(config?: OptOutRequestInternalOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reqIdIsSet == true && other?.reqIdIsSet == true)
      return this.reqId == other.reqId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reqId) {
      this.reqIdIsSet = true;
    }

    this.optOutGrpId?.setIds();
  }
  assignFrom(
    config: OptOutRequestInternalOptional,
    options?: AssignOptions,
  ): OptOutRequestInternalTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.reqId && this.reqIdApplyFilter(optionsRequired.filter)) {
      this.reqId = config.reqId;
      if (optionsRequired.unassign) this.reqIdIsSet = false;
      else this.reqIdIsSet = true;
    }
    if (config.doNotSend && this.doNotSendApplyFilter(optionsRequired.filter)) {
      this.doNotSend = config.doNotSend;
      if (optionsRequired.unassign) this.doNotSendIsSet = false;
      else this.doNotSendIsSet = true;
    }
    if (config.token && this.tokenApplyFilter(optionsRequired.filter)) {
      this.token = config.token;
      if (optionsRequired.unassign) this.tokenIsSet = false;
      else this.tokenIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.optOutGrpId &&
      this.optOutGrpIdApplyFilter(optionsRequired.filter)
    ) {
      this.optOutGrpId = new OptOutGroupRefTracked(config.optOutGrpId, options);
      if (optionsRequired.unassign) this.optOutGrpIdIsSet = false;
      else this.optOutGrpIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutRequestInternalTrackedI {
    const cloned = {} as OptOutRequestInternalTrackedI;
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.reqIdIsSetDeep() &&
      this.reqIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reqIdIsSet = true;
      cloned.reqId = this.reqId;
    } else {
      //cloned.reqIdIsSet = false
    }
    if (
      this.doNotSendIsSetDeep() &&
      this.doNotSendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotSendIsSet = true;
      cloned.doNotSend = this.doNotSend;
    } else {
      //cloned.doNotSendIsSet = false
    }
    if (
      this.tokenIsSetDeep() &&
      this.tokenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tokenIsSet = true;
      cloned.token = this.token;
    } else {
      //cloned.tokenIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.optOutGrpIdIsSetDeep() &&
      this.optOutGrpIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.optOutGrpIdIsSet = true;
      cloned.optOutGrpId = this.optOutGrpId?.removeUnset(filter);
    } else {
      //cloned.optOutGrpIdIsSet = false
    }
    if (!isDeleted(this) && !this.reqIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutRequestInternalTrackedI {
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.reqIdApplyFilter(filter)) this.reqIdIsSet = false;

    if (!this.doNotSendApplyFilter(filter)) this.doNotSendIsSet = false;

    if (!this.tokenApplyFilter(filter)) this.tokenIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.optOutGrpIdApplyFilter(filter)) this.optOutGrpIdIsSet = false;
    this.optOutGrpId?.unassignAll(filter);

    return this;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.updatedOn,
      OptOutRequestInternalMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.updatedBy,
      OptOutRequestInternalMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.createdOn,
      OptOutRequestInternalMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.createdBy,
      OptOutRequestInternalMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  reqIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.reqId,
      OptOutRequestInternalMeta,
      this.reqId,
      this,
    );
  }
  reqIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reqIdIsSet && this.reqIdApplyFilter(filter)) return true;

    return false;
  }
  doNotSendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.doNotSend,
      OptOutRequestInternalMeta,
      this.doNotSend,
      this,
    );
  }
  doNotSendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotSendIsSet && this.doNotSendApplyFilter(filter)) return true;

    return false;
  }
  tokenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.token,
      OptOutRequestInternalMeta,
      this.token,
      this,
    );
  }
  tokenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tokenIsSet && this.tokenApplyFilter(filter)) return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.email,
      OptOutRequestInternalMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  optOutGrpIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestInternalMeta.optOutGrpId,
      OptOutRequestInternalMeta,
      this.optOutGrpId,
      this,
    );
  }
  optOutGrpIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.optOutGrpIdIsSet && this.optOutGrpIdApplyFilter(filter))
      return true;
    return this.optOutGrpId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.reqIdIsSetDeep(filter)) return true;
    if (this.doNotSendIsSetDeep(filter)) return true;
    if (this.tokenIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.optOutGrpIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
